import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  paper: {
    width: "min-content",
    padding: 16,
    display: "flex",
    "& $controls": {
      paddingTop: 40
    },
    [theme.breakpoints.up("xs")]: {
      minWidth: 376
    }
  },
  paperEnabling: {
    "& $controls": {
      paddingTop: 24
    }
  },
  content: {
    display: "flex",
    flex: "auto",
    flexDirection: "column"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: 20
  },
  headerTitle: {
    fontSize: 20,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8
  },
  dates: {
    display: "flex",
    paddingBottom: 24
  },
  dateBox: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    cursor: "pointer"
  },
  dateTitle: {
    fontSize: 12,
    color: theme.palette.text.secondary
  },
  subtitle: {
    display: "block",
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 24
  },
  dateBold: {
    display: "block",
    color: "#1a1a1a",
    fontSize: 16,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  repeatanceBlock: {
    paddingBottom: 8
  },
  repeatanceSelect: {
    "&:before, &:after": {
      display: "none"
    }
  },
  description: {
    flex: "auto"
  },
  controls: {
    display: "flex",
    alignItems: "flex-end",
    flex: "auto",
    justifyContent: "flex-end",
    paddingTop: 24
  },
  control: {
    borderRadius: 3,
    marginLeft: 24,
    border: `1px solid ${theme.palette.text.hint}`,
    color: theme.palette.text.secondary,
    width: 94,
    height: 36,
    fontSize: 14,
    textTransform: "none"
  },
  nextControl: {
    color: theme.palette.common.white,
    backgroundColor: "#000000",
    border: "1px solid #000000",
    width: 124,
    "&:hover": {
      backgroundColor: "#000000"
    }
  },
  confirmControl: {
    color: theme.palette.common.white,
    border: "1px solid #ff4a4e",
    backgroundColor: "#ff4a4e",
    width: 124,
    "&:hover": {
      backgroundColor: "#ff4a4e"
    }
  },
  enableControl: {
    color: theme.palette.common.white,
    border: `1px solid ${theme.palette.secondary.dark}`,
    backgroundColor: theme.palette.secondary.dark,
    width: 124,
    "&:hover": {
      backgroundColor: "#53AA88"
    }
  },
  nowrap: {
    whiteSpace: "nowrap"
  },
  facilityName: {
    whiteSpace: "nowrap",
    textTransform: "capitalize"
  },
  listItemTitle: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 24,
    marginBottom: 12
  },
  listItem: {
    padding: "0"
  },
  listItemButton: {
    justifyContent: "flex-start",
    padding: "8px 0",
    textTransform: "initial"
  },
  listItemCheckedIcon: {
    fill: theme.palette.secondary.dark,
    marginRight: 12
  },
  listItemUncheckedIcon: {
    fill: theme.palette.primary.light,
    marginRight: 12
  },
  listItemText: {
    fontSize: "14px"
  }
}));
